<template>
  <div v-if="loggedIn" id="app" class="wrapper">
    <header class="main-header">

      <router-link v-if="loggedIn" tag="span" to="/overview"><a class="logo" href="#"><span class="logo-mini">M</span><span class="logo-lg">M-Tinker -
        planIS</span></a></router-link>
      <router-link v-else tag="span" to="/login"><a class="navbar-brand" href="#">M-Tinker - Informačný systém</a></router-link>

      <nav class="navbar navbar-static-top">
        <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>

        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" v-if="user"> {{ user.fullName }}
                <span class="caret"></span></a>
              <ul class="dropdown-menu">
                <router-link tag="li" to="/profile" active-class="active"><a>Môj profil</a></router-link>
                <router-link tag="li" to="/password-change" active-class="active"><a>Zmena hesla</a></router-link>
                <li role="separator" class="divider"></li>
                <li><a href="" @click.prevent="logout()">Odhlásit</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <div class="sidebar-wrapper">

    <aside class="main-sidebar">

        <!-- sidebar: style can be found in sidebar.less -->
        <section class="sidebar">

          <!-- Sidebar Menu -->
          <ul class="sidebar-menu tree" data-widget="tree">
            <!-- Optionally, you can add icons to the links -->

            <router-link v-if="hasSomeRole(['DEALER', 'DEALER_L2'])" tag="li" to="/overview" active-class="active"><a><i class="fa fa-file-o"></i><span>Prehľad</span></a></router-link>
            <router-link v-if="hasSomeRole(['DEALER', 'DEALER_L2', 'DRIVER'])" tag="li" to="/orders" active-class="active"><a><i class="fa fa-globe"></i><span>Plán rozvozu</span></a></router-link>
            <router-link v-if="hasSomeRole(['DEALER', 'DEALER_L2'])" tag="li" to="/reports" active-class="active"><a><i class="fa fa-print"></i><span>Tlačové zostavy</span></a></router-link>

            <li v-if="hasRole('ADMIN')" class="treeview">
              <a href="#"><i class="fa fa-cog"></i> <span>Administrácia</span>
                <span class="pull-right-container">
                  <i class="fa fa-angle-left pull-right"></i>
                </span>
              </a>
              <ul class="treeview-menu">
                <router-link  tag="li" to="/users" active-class="active"><a><i class="fa fa-user"></i>Užívatelia</a></router-link>
                <router-link  tag="li" to="/customers" active-class="active"><a><i class="fa fa-address-book"></i>Zákazníci</a></router-link>
                <router-link  tag="li" to="/price-lists" active-class="active"><a><i class="fa fa-eur"></i>Cenníky</a></router-link>
                <router-link  tag="li" to="/areas" active-class="active"><a><i class="fa fa-globe"></i>Oblasti</a></router-link>
                <router-link  tag="li" to="/products" active-class="active"><a><i class="fa fa-cube"></i>Produkty</a></router-link>
              </ul>
            </li>
          </ul>
          <!-- /.sidebar-menu -->
        </section>
        <!-- /.sidebar -->
      </aside>

    </div>
    <div class="content-wrapper">
      <router-view></router-view>
    </div>
    <footer class="main-footer hidden-print">
      <confirmation-modal :show-model="showConfirmationModal" :text="confirmationText" @cancel="confirmationCancel()" @confirm="confirmationDone()"></confirmation-modal>
      <span class="text-muted pull-right">Copyright &copy; 2017 <a href="http://www.jedleknedle.sk" target="_blank">M-Tinker, s.r.o.</a> </span>
      <div class="clearfix"></div>
    </footer>
  </div>
  <div v-else>
    <router-view></router-view>
  </div>
</template>

<script>
  import authService from 'services/authService';
  import {mapGetters, mapState} from 'vuex';
  import eventBus from 'services/eventBus';
  import confirmationModal from 'components/confirmationModal';
  import i18n from 'i18n/';

  export default {
    components: { confirmationModal },
    data: () => ({
        showConfirmationModal: false,
        confirmationText: null,
        placement: 'top',
        type: 'default'
    }),
    computed: {
      ...mapState({
        user: (state) => state.auth.user
      }),
      ...mapGetters({
        loggedIn: 'auth/loggedIn',
        hasRole: 'auth/hasRole',
        hasSomeRole: 'auth/hasSomeRole'
      })
    },
    methods: {
      logout () {
        authService.logOut();
        this.$store.dispatch('auth/logOut');
        this.$router.push('/login');
      },
      confirmationCancel() {
          eventBus.$emit('cancelled');
          this.showConfirmationModal = false;
      },
      confirmationDone() {
          eventBus.$emit('confirmed');
          this.showConfirmationModal = false;
      }
    },
    mounted() {
      this.$store.dispatch('app/loadConfiguration');
      eventBus.$on('confirmAction', (confirmationTextKey, args) => {
          this.showConfirmationModal = true;
          this.confirmationText = i18n.message(confirmationTextKey, args);
      });
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/app.vue